import { Modal } from "@js/components/modal";

export const GenericMessengerModalInstance = Modal("generic-messenger-modal");

export const closeGenericMessenger = () => {
  GenericMessengerModalInstance.close();
};
